/**
 * Shared dashboard utilities (formatDate, cleanText, auth helpers, review modal keys).
 * Used by Dashboard and tab components.
 */

export const REVIEW_SHOWN_KEY = 'booksy_review_modal_shown';

export const getReviewShownIds = () => {
  try {
    const raw = sessionStorage.getItem(REVIEW_SHOWN_KEY);
    return new Set(raw ? JSON.parse(raw) : []);
  } catch {
    return new Set();
  }
};

export const markReviewShown = (bookingId) => {
  const set = getReviewShownIds();
  set.add(bookingId);
  try {
    sessionStorage.setItem(REVIEW_SHOWN_KEY, JSON.stringify([...set]));
  } catch {}
};

export const shouldAutoShowReview = (bookingId) =>
  !getReviewShownIds().has(bookingId);

export function formatDate(dateString) {
  if (!dateString) return '';
  if (/^\d{8}$/.test(dateString)) {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    return `${year}/${month}/${day}`;
  }
  try {
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) return date.toLocaleDateString('en-CA');
  } catch {}
  return dateString;
}

export const safe = (v) =>
  v === undefined || v === null || v === '' ? '—' : v;

/** iOS Safari sometimes renders stray glyphs in numeric boxes. */
export const cleanText = (t) =>
  String(t ?? '').replace(/[|‖¦\-‑–—]/g, '');

export const getCookie = (name) => {
  const m = document.cookie
    .split('; ')
    .find((r) => r.startsWith(name + '='));
  return m ? decodeURIComponent(m.split('=').slice(1).join('=')) : '';
};

export const xsrf = () => getCookie('XSRF-TOKEN');

export const pick = (obj, keys) => {
  const foundKey = keys.find((k) => obj?.[k]);
  return foundKey ? obj[foundKey] : '—';
};
